export enum ChatConnectionState {
    Uninitialized = "Uninitialized",
    Connected = "Connected",
    Reconnecting = "Reconnecting",
    Closed = "Closed",
}
